import React from "react";
import IconUser from "../componentsStyled/icon/IconUser";
import { Box } from "@mui/material";

interface FollowDataProps {
  devolutionData: devolutionData;
}
type devolutionData = {
  id: number;
  status_id: number;
  order_id: number;
  method_shipment: string;
  dateCreatedReturn: string;
  customer: {
    fullname: string;
    fone: string;
    cellphone: string;
    cep: string;
    state: string;
    city: string;
    neigh_borhood: string;
    street: string;
    number: string;
    complement: string;
  };
  products: Array<{
    name: string;
    image: string;
    quant: number;
    price: string;
    refundType: string;
    reasonSub: string;
    reasonMain: string;
    obs: string;
    variant: string;
    url_pdf: any;
  }>;
  history: Array<{
    title: string;
    date: string;
    fileIcon: string;
    status: string;
  }>;
  status: {
    title: string;
    status: string;
    msg: string;
    color: string;
  };
  coupon: any;
  ldn: {
    status: boolean;
    url: string;
  };
};
const FollowData: React.FC<FollowDataProps> = ({ devolutionData }) => {
  return (
    <>
      {devolutionData && (
        <Box width={{ xs: "80%", md: "50%" }} paddingX={2} mt={{ xs: 3, md: 0 }}>
          <Box display={{ xs: "none", md: "flex" }} flexDirection={"row"} alignItems={"center"} gap={2} ml={1} mt={2} mb={2}>
            <IconUser width={28} />
            <p>Meus Dados</p>
          </Box>

          <div>
            <p style={{ fontSize: 23, fontWeight: 900 }}>Dados Pessoais</p>
            <Box marginY={1}>
              <label style={{ color: "rgb(172, 172, 172)" }}>Nome</label>
              <p>{devolutionData.customer.fullname}</p>
            </Box>

            <div style={{ display: "flex", alignItems: "center", gap: "40%" }}>
              <Box marginY={1}>
                <label style={{ color: "rgb(172, 172, 172)" }}>Telefone</label>
                <p>{devolutionData.customer.fone || "-"}</p>
              </Box>
              <Box marginY={1}>
                <label style={{ color: "rgb(172, 172, 172)" }}>Celular</label>
                <p>{devolutionData.customer.cellphone}</p>
              </Box>
            </div>

            <p style={{ fontSize: 23, fontWeight: 900 }}>Endereço</p>

            <div style={{ display: "flex", alignItems: "center", gap: "40%" }}>
              <Box marginY={1}>
                <label style={{ color: "rgb(172, 172, 172)" }}>CEP</label>
                <p>{devolutionData.customer.cep}</p>
              </Box>
              <Box marginY={1}>
                <label style={{ color: "rgb(172, 172, 172)" }}>Estado</label>
                <p>{devolutionData.customer.state}</p>
              </Box>
            </div>

            <Box marginY={1}>
              <label style={{ color: "rgb(172, 172, 172)" }}>Cidade</label>
              <p>{devolutionData.customer.city}</p>
            </Box>

            <Box marginY={1}>
              <label style={{ color: "rgb(172, 172, 172)" }}>Bairro</label>
              <p>{devolutionData.customer.neigh_borhood || "-"}</p>
            </Box>

            <Box marginY={1}>
              <label style={{ color: "rgb(172, 172, 172)" }}>Logradouro</label>
              <p>{devolutionData.customer.street}</p>
            </Box>

            <div style={{ display: "flex", alignItems: "center", gap: "30%" }}>
              <Box marginY={1}>
                <label style={{ color: "rgb(172, 172, 172)" }}>Número</label>
                <p>{devolutionData.customer.number}</p>
              </Box>
              <Box marginY={1}>
                <label style={{ color: "rgb(172, 172, 172)" }}>Complemento</label>
                <p>{devolutionData.customer.complement || "-"}</p>
              </Box>
            </div>
          </div>
        </Box>
      )}
    </>
  );
};

export default FollowData;
